import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'creditNoteReason',
    standalone: true
})
export class CreditNoteReasonPipe implements PipeTransform {

    transform(reason: string): string {
        switch (reason) {
            case 'OVERPAYMENT':
                return 'Overpayment';
            case 'REFERRAL':
                return 'Referral';
            case 'DISCOUNT':
                return 'Discount';
            case 'REFUND':
                return 'Refund';
            case 'OTHER':
                return 'Other';
            default:
                return 'Unknown';
        }
    }
}
